import { Navigate, useLocation } from 'react-router-dom';

import { history } from '../helpers';
import { readCachedUserV104 } from '../helpers/authSessionV104';


function PrivateRoute({ children }) {
  const { pathname } = useLocation();
  if (!localStorage.getItem('user')) {
    return <Navigate to='/login' state={{ from: history.location }} />;
  }
  if (readCachedUserV104()?.account_kind_v110 === 'staff' && pathname !== '/staff' && !pathname.startsWith('/staff/')) {
    return <Navigate to={pathname.startsWith('/setting') ? '/staff/security' : '/staff'} replace />;
  }
  return children;
}

export { PrivateRoute };
